import { createIcon } from '@chakra-ui/icon'

const NotFoundGraphic = createIcon({
  viewBox: '0 0 260 200',
  path: (
    <g>
      <defs>
        <style>
          {
            '.st2{fill:#5f7970}.st3{fill:#64c99f}.st4{fill:#ffd917}.st6{fill:#fff}.st8{fill:#87c5f9}'
          }
        </style>
      </defs>
      <g>
        <g style={{ opacity: 0.83 }}>
          <path
            d="M172.8 28.6c-1 2.4-2.6 4.5-3.6 7-2.6 6.7-17.6 37.5-71.8 36.1-60.9-1.5-95.6 27-89 66.3 10 59.8 116.9 75.1 191.7 39.9s64.7-134 35.6-156.9C211 1.5 181.4 8.4 172.8 28.6z"
            style={{ fill: '#e2ebff' }}
          />
        </g>
        <path
          d="M200.3 176.3c3.2-9.3 28.1-30.8 28.2-31l.5.5c-.2.2-25 21.7-28.2 30.9l-.5-.4z"
          className="st2"
        />
        <path
          d="M222.6 126.6c-3.5-1.5-6 .2-6.4 3.3-.4 3.1-2.7 4.8-4.3 5.8s-2.3 3.6-.3 6c2 2.5.6 2.9-1 6.3-1.6 3.3 2.6 11.1 4.9 9.7 2.3-1.4 5.1-7 4.9-10.1s1.8-3.3 2.9-5.2c1.1-1.9-.9-3.6-.5-5.7.3-2.2 8.3-6.4-.2-10.1z"
          className="st3"
        />
        <path
          d="M216.3 156.6c-1-13.4 6.2-27.8 6.3-27.9l.4.2c-.1.1-7.2 14.4-6.2 27.7h-.5z"
          className="st2"
        />
        <path
          d="M247.8 147.9c1.7 3.5-.1 6.3-3.3 6.9-3.3.7-5 3.2-5.9 5-1 1.8-3.7 2.8-6.3.9-2.6-1.9-3.1-.4-6.6 1.6-3.5 1.9-11.7-1.7-10.3-4.2 1.5-2.5 7.2-5.9 10.5-6 3.3-.1 3.4-2.2 5.4-3.5 2-1.3 3.8.6 6 .1s6.4-9.3 10.5-.8z"
          className="st3"
        />
        <path
          d="M216.3 157v-.4c14-.1 29.6-9.2 29.7-9.3l.2.4c-.1 0-15.8 9.2-29.9 9.3z"
          className="st2"
        />
        <path
          d="M228.7 145.4s.2-8.3 2.8-7.3c2.7 1-2.8 7.3-2.8 7.3zM228.7 145.4s8.2-1.3 7.7 1.5c-.5 2.8-7.7-1.5-7.7-1.5z"
          className="st4"
        />
        <path
          d="M228.4 145.7c0-.1-.1-.1 0-.2l1.4-4.1c0-.1.1-.1.2-.1s.1.1.1.2l-1.3 3.9 4 .4c.1 0 .2.1.1.2 0 .1-.1.2-.2.1l-4.2-.4c0 .1-.1.1-.1 0zM49.5 111.7c-3.2-9.3-28.1-30.8-28.2-31l-.5.5c.2.2 25 21.7 28.2 30.9l.5-.4z"
          className="st2"
        />
        <path
          d="M27.3 62c3.5-1.5 6 .2 6.4 3.3.4 3.1 2.7 4.8 4.3 5.8 1.7.9 2.3 3.6.3 6-2 2.5-.6 2.9 1 6.3 1.6 3.3-2.6 11.1-4.9 9.7-2.3-1.4-5.1-7-4.9-10.1.2-3.1-1.8-3.3-2.9-5.2-1.1-1.9.9-3.6.5-5.7-.3-2.2-8.3-6.4.2-10.1z"
          className="st3"
        />
        <path
          d="M33.5 92c1-13.4-6.2-27.8-6.3-27.9l-.4.2c.1.1 7.2 14.4 6.2 27.7h.5z"
          className="st2"
        />
        <path
          d="M2.1 83.3c-1.7 3.5.1 6.3 3.3 6.9 3.3.7 5 3.2 5.9 5 1 1.8 3.7 2.8 6.3.9 2.6-1.9 3.1-.4 6.6 1.6 3.5 1.9 11.7-1.7 10.3-4.2-1.5-2.5-7.2-5.9-10.5-6-3.3-.1-3.4-2.2-5.4-3.5-2-1.3-3.8.6-6 .1s-6.5-9.3-10.5-.8z"
          className="st3"
        />
        <path
          d="M33.5 92.4V92c-14-.1-29.6-9.2-29.7-9.3l-.3.3c.2.1 15.9 9.3 30 9.4z"
          className="st2"
        />
        <path
          d="M21.1 80.8s-.2-8.3-2.8-7.3c-2.7 1 2.8 7.3 2.8 7.3zM21.1 80.8s-8.2-1.3-7.7 1.5c.6 2.8 7.7-1.5 7.7-1.5z"
          className="st4"
        />
        <path
          d="M21.4 81.2s.1 0 0 0c0-.1.1-.1 0-.2L20 76.9c0-.1-.1-.1-.2-.1s-.1.1-.1.2l1.3 3.9-4 .4c-.1 0-.2.1-.1.2 0 .1.1.2.2.1l4.2-.4h.1z"
          className="st2"
        />
        <path
          id="XMLID_156_"
          d="M129.1 52v-2.2c0-3.6-2.9-6.5-6.5-6.5H55.3c-3.6 0-6.5 2.9-6.5 6.5v116.4h160.4V58.4c0-3.6-2.9-6.5-6.5-6.5h-73.6z"
          style={{ fill: '#2c93fb' }}
        />
        <path id="XMLID_154_" d="M56 61.3h147.7v106.1H56z" className="st6" />
        <path
          id="XMLID_149_"
          d="m126.8 74.5-2.4 6.6H55.3c-3.6 0-6.5 2.9-6.5 6.5v82.2c0 3.6 2.9 6.5 6.5 6.5h147.5c3.6 0 6.5-2.9 6.5-6.5V76.7c0-3.6-2.9-6.5-6.5-6.5h-70c-2.7.1-5.1 1.8-6 4.3z"
          style={{ fill: '#5ba8f8' }}
        />
        <path
          d="M209.3 169.8v-53.6c-44.6 43.3-121.9 54.9-158.7 58 1.2 1.2 2.8 2 4.7 2h147.5c3.6 0 6.5-2.9 6.5-6.4zM114 86.3H59.4c-2.9 0-5.2 2.3-5.2 5.2V103c9.2-6.2 29.9-14.1 59.8-16.7z"
          className="st8"
        />
        <circle cx="128.3" cy="126.1" r="26.5" className="st6" />
        <path
          d="M129 113.7c5.4 0 9.2 3.3 9.2 8.5 0 6.1-4.2 8.5-10 8.5l-.1 3.9h-3.3l-.2-6.5h1.2c4.7 0 8.7-.9 8.7-5.9 0-3.3-2.2-5.4-5.5-5.4-3.4 0-5.5 1.9-5.5 5.2H120c-.1-5 3.6-8.3 9-8.3zm-2.9 30.1c-1.5 0-2.6-1.1-2.6-2.6s1.1-2.6 2.6-2.6c1.4 0 2.5 1.1 2.5 2.6 0 1.4-1.1 2.6-2.5 2.6z"
          style={{
            fill: '#5ba8f8',
            stroke: '#5ba8f8',
            strokeWidth: 2,
            strokeMiterlimit: 10,
          }}
        />
      </g>
    </g>
  ),
})

export default NotFoundGraphic
